import React from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";

const Pagination = (props) => {
  const { totalPageCount, setPageNumber, limit } = props;
  const pageCount = Math.ceil(totalPageCount / limit);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  return (
    <ReactPaginate
      previousLabel={"Prev"}
      nextLabel={"Next"}
      pageCount={pageCount}
      onPageChange={changePage}
      containerClassName={"paginationBttns"}
      previousLinkClassName={"previousBttn"}
      nextLinkClassName={"nextBttn"}
      disabledClassName={"paginationDisabled"}
      activeClassName={"paginationActive"}
    />
  );
};

export default Pagination;
